import React from "react";
import { Form } from "react-bootstrap";
import Names from "../form/Names";
import SSN from "../form/SSN";

export default function DeceasedIndividual(props) {
  return (
    <>
      <h5>Deceased individual</h5>
      <Names id="deceased" onChange={props.onChange} state={props.state} />
      <Form.Group controlId="deceasedSuffixName">
        <Form.Label>Suffix Name (optional)</Form.Label>
        <Form.Control
          as="select"
          onChange={props.onChange}
          value={props.state.deceasedSuffixName}
        >
          <option value="">Please Select</option>
          <option value="DDS">DDS</option>
          <option value="MD">MD</option>
          <option value="PhD">PhD</option>
          <option value="JR">JR</option>
          <option value="SR">SR</option>
          <option value="I">I</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="IV">IV</option>
          <option value="V">V</option>
          <option value="VI">VI</option>
        </Form.Control>
      </Form.Group>
      <SSN id="deceased" state={props.state} onChange={props.onChange} />
    </>
  );
}
